import tvAsset from "@/assets/entertainment-tv.png.asset.json";
import { Globe2, Languages, Trophy } from "lucide-react";

const items = [
  { icon: Languages, title: "Regional Content", body: "Local channels in multiple Indian languages — entertainment that speaks to you." },
  { icon: Globe2, title: "International Channels", body: "Global content from BBC, CNN, Discovery and more international favourites." },
  { icon: Trophy, title: "Sports & Movies", body: "Live sports, latest movies, and exclusive web series — never miss a moment." },
];

export function Entertainment() {
  return (
    <section className="bg-background py-16 sm:py-24">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 lg:grid-cols-2">
        <div>
          <h2 className="text-3xl font-black tracking-tight sm:text-4xl">
            Unlimited Entertainment <span className="text-accent">at Your Fingertips</span>
          </h2>
          <p className="mt-3 text-muted-foreground">
            From regional favourites to global blockbusters — everything you love, in one place.
          </p>
          <ul className="mt-8 space-y-5">
            {items.map(({ icon: Icon, title, body }) => (
              <li key={title} className="flex gap-4">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-accent/10 text-accent">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="text-lg font-bold">{title}</h3>
                  <p className="text-sm text-muted-foreground">{body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative">
          <div className="absolute inset-0 -z-10 rounded-3xl bg-accent/20 blur-3xl" />
          <img
            src={tvAsset.url}
            alt="Smart TV showing diverse entertainment content"
            loading="lazy"
            width={754}
            height={520}
            className="w-full rounded-3xl shadow-[var(--shadow-elevated)]"
          />
        </div>
      </div>
    </section>
  );
}
